import React from "react";
import { BehaviorCorrelation } from "../../types/tradingJournal";
import { ArrowUpIcon, ArrowDownIcon } from "lucide-react";

interface BehaviorCorrelationTableProps {
  correlations: BehaviorCorrelation[];
}

const BehaviorCorrelationTable = ({
  correlations,
}: BehaviorCorrelationTableProps) => {
  // Sort correlations by avgPnL
  const sortedCorrelations = [...correlations].sort(
    (a, b) => b.avgPnL - a.avgPnL
  );

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-white/10">
            <th className="text-left py-2 text-white/70 font-medium">
              Behavior
            </th>
            <th className="text-right py-2 text-white/70 font-medium">
              Avg P&L
            </th>
            <th className="text-right py-2 text-white/70 font-medium">
              Win Rate
            </th>
            <th className="text-right py-2 text-white/70 font-medium">
              Occurrence
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedCorrelations.map((correlation, index) => (
            <tr
              key={index}
              className="border-b border-white/5 hover:bg-white/5"
            >
              <td className="py-2">
                <span className="text-white/90">{correlation.behavior}: </span>
                <span className="text-white/70">{correlation.value}</span>
              </td>
              <td
                className={`py-2 text-right ${
                  correlation.avgPnL >= 0 ? "text-green-400" : "text-red-400"
                } font-medium`}
              >
                <div className="flex items-center justify-end">
                  {correlation.avgPnL >= 0 ? (
                    <ArrowUpIcon className="w-4 h-4 mr-1" />
                  ) : (
                    <ArrowDownIcon className="w-4 h-4 mr-1" />
                  )}
                  ₹{correlation.avgPnL.toFixed(2)}
                </div>
              </td>
              <td className="py-2 text-right text-white/90 font-medium">
                {correlation.winRate.toFixed(1)}%
              </td>
              <td className="py-2 text-right text-white/70">
                {correlation.occurrenceRate.toFixed(1)}%
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {correlations.length === 0 && (
        <div className="text-center py-8 text-white/60">
          <p>Not enough data to display correlations</p>
        </div>
      )}
    </div>
  );
};

export default BehaviorCorrelationTable;
